import React from 'react';

const ProcessSteps = () => {
  return (
    <div className='p-6 border-b border-slate-200 bg-gradient-to-b from-slate-50 to-white'>
      <h2 className='text-lg font-semibold text-slate-900 mb-4'>Proceso simplificado y seguro</h2>
      <div className='space-y-4'>
        <div className='flex items-start'>
          <div className='flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4'>
            <span className='text-blue-600 font-semibold'>1</span>
          </div>
          <div>
            <h3 className='text-slate-800 font-medium mb-1'>Pago Seguro</h3>
            <p className='text-slate-600 text-sm'>Procesado por nuestra plataforma segura de pagos online</p>
          </div>
        </div>
        <div className='flex items-start'>
          <div className='flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4'>
            <span className='text-blue-600 font-semibold'>2</span>
          </div>
          <div>
            <h3 className='text-slate-800 font-medium mb-1'>Confirmación Inmediata</h3>
            <p className='text-slate-600 text-sm'>Recibirás un email con el comprobante de pago al instante</p>
          </div>
        </div>
        <div className='flex items-start'>
          <div className='flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-4'>
            <span className='text-blue-600 font-semibold'>3</span>
          </div>
          <div>
            <h3 className='text-slate-800 font-medium mb-1'>Expediente Resuelto</h3>
            <p className='text-slate-600 text-sm'>
              Tu deuda quedará completamente saldada sin reclamaciones futuras
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessSteps;
